module.exports = __webpack_public_path__ + "media/images/icons/twitter_dark-85f2f4cb95862020df3e10f8111dcfac.svg";